'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import type { Subscription } from '@/types/contentful';

interface SubscriptionContextType {
  subscriptions: Subscription[];
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export function SubscriptionProvider({ 
  children, 
  subscriptions = [] 
}: { 
  children: ReactNode; 
  subscriptions?: Subscription[];
}) {
  return (
    <SubscriptionContext.Provider value={{ subscriptions }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useGlobalSettings() {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    return { subscriptions: [] }; // Fallback if used outside provider
  }
  return context;
}
